<template>
	<div class="answer highlighted-content">
		<div v-if="isAbacusMode" class="abacus">
			<Abacus v-show="false" readOnly="true" />
		</div>

		<div class="expression">{{ expression }}</div>
		<h2 class="text-uppercase">{{ 'ANSWER' | translate }}</h2>

		<div @click="onClickFocus">
			<input v-model="answer" @keyup.enter="$emit('checkAnswer', answer)" id="answer" type="text" autocomplete="off" />
		</div>

		<button @click="$emit('checkAnswer', answer)" class="btn btn-lg btn-pink text-uppercase">
			{{ 'Send' | translate }}
		</button>
	</div>
</template>

<script>
import Abacus from './Abacus'
export default {
	components: {
		Abacus,
	},
	props: {
		isAbacusMode: Boolean,
		expression: {
			type: String,
		},
	},
	computed: {
		isCustomBgEnabled() {
			return !!this.$store.getters.primaryBackground
		},
	},
	data() {
		return {
			answer: '',
		}
	},
	watch: {
		answer(newAnswer, _) {
			if (newAnswer == '00' || (newAnswer[0] == '0' && newAnswer.length > 1)) {
				this.answer = '0'
			}
		},
	},
	methods: {
		onClickFocus(event) {
			console.log('Has focus: ', document.hasFocus())
			console.log('On focus: ', document.activeElement.id)

			// if (document.activeElement?.id !== 'answer') { }

			document.getElementById('answer').focus()
		},
	},
	mounted() {
		this.$nextTick(function () {
			document.getElementById('answer').focus()
		})
	},
}
</script>

<style scoped lang="scss">
.abacus {
	margin-bottom: 24px;
}

h2 {
	font-size: 50px;
	color: #e4467b;
}

.expression {
	color: #e4467b;
	font-weight: 700;
	font-family: 'Roboto Condensed', sans-serif;
	font-size: 80px;
}

.answer {
	width: fit-content;
	margin: auto;
	padding: 12px;
	max-width: 100%;

	&.highlighted-content {
		background: #fff;
		border-radius: 12px;
		border: 2px solid red;
		color: #e4467b;

		input {
			border: 1px solid grey !important;
		}
	}
}

.answer input {
	width: 1000px !important;
	display: block !important;
	margin: 20px auto 10px !important;
	height: 180px !important;
	font-size: 120px !important;
	text-align: center !important;
	max-width: 70% !important;
}

.answer input::-webkit-outer-spin-button,
.answer input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

.answer input[type='number'] {
	-moz-appearance: textfield;
}

.btn-pink {
	background-color: #e4467b;
	color: #fff;
	height: 50px;
	margin: 10px 0;
	width: 260px;
	cursor: pointer;
}

@media (max-width: 480px) {
	.answer input {
		width: 310px;
		max-width: 70%;
	}
}
</style>
